import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { MonthModel } from '../models/month.model';
import { InfraService } from './infra.service';

@Injectable()
export class MonthService {
  private configUrl: string;

  constructor(private infraService: InfraService, private http: HttpClient) {
   

    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint2 + 'month';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

    }

  public getAllMonths(): Observable<MonthModel[]> {
    return this.http.get<MonthModel[]>(`${this.configUrl}` + '/' + 'getAllMonths');
        
  } 

    private handleError(error: Response) {
      return throwError(()=> error);
    }
}
